import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import dsn1 from '../../images/destination/kohkood.webp';
import dsn2 from '../../images/destination/kohchang.webp'; //Koh Mak
import dsn3 from '../../images/destination/chiangrai.webp';
import dsn4 from '../../images/destination/chiangmai.webp';
import dsn5 from '../../images/destination/nakhon_phanom.webp'; 
import dsn6 from '../../images/destination/ubonratchathani2.webp'; 
import dsn7 from '../../images/destination/isan.webp'; // Change to actual image Surin
import dsn8 from '../../images/destination/northern_thailand.webp'; // Change to actual image mukdahan
import dsn9 from '../../images/destination/isan.webp';
import dsn10 from '../../images/destination/green-rice-paddy-fields-in-central-thailand-suphan.webp'; 
import dsn11 from '../../images/destination/nong_khai.webp';
import dsn12 from '../../images/destination/khonkaen.webp'; // Change to actual image khonkaen
import '../Destination/style.css';

// Destination data array
const destinations_cc = [
  {
    id: 1,
    image: dsn1,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-ekkamai/koh-kood-sueadum-go-pier-ao-salad/256159',
    title: 'Bangkok ↔ Koh Kood',
    frequency: 'routes.Daily',
    price: '1129THB',
  },  
  {
    id: 2,
    image: dsn2,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-ekkamai/koh-mak-ao-nid-pier-sueadum-go/256166',
    title: 'Bangkok ↔ Koh Mak',
    frequency: 'routes.Daily',
    price: '1079THB',
  },  
  {
    id: 3,
    image: dsn3,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/chiang-rai-bus-terminal-2/834',
    title: 'Bangkok ↔ Chiang Rai',
    frequency: 'routes.Daily',
    price: '650THB',
  },
  {
    id: 4,
    image: dsn4,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/chiang-mai-bus-terminal-3-arcade/3494',
    title: 'Bangkok ↔ Chiang Mai',
    frequency: 'routes.Daily',
    price: '595THB',
  },
  {
    id: 5,
    image: dsn5,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/nakhon-phanom-bus-terminal/442',
    title: 'Bangkok ↔ Nakhon Phanom',
    frequency: 'routes.Daily',
    price: '675THB',
  },
  {
    id: 6,
    image: dsn6,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/ubon-ratchathani-bus-terminal/827',
    title: 'Phuket ↔ Ubon Ratchathani',
    frequency: 'routes.Daily',
    price: '544THB',
  },
  {
    id: 7,
    image: dsn7,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/khon-kaen-bus-terminal-3/365',
    title: 'Bangkok ↔ Khon Kaen',
    frequency: 'routes.Daily',
    price: '380THB',
  },
  {
    id: 8,
    image: dsn8,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/sisaket-bus-terminal/708',
    title: 'Bangkok ↔ Sisaket',
    frequency: 'routes.Daily',
    price: '413THB',
  },
  {
    id: 9,
    image: dsn9,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/kap-choeng/4579',
    title: 'Bangkok ↔ Surin',
    frequency: 'routes.Daily',
    price: '346THB',
  },
  {
    id: 10,
    image: dsn10,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/mukdahan-bus-terminal/631',
    title: 'Bangkok ↔ Mukdahan',
    frequency: 'routes.Daily',
    price: '535THB',
  },
  {
    id: 11,
    image: dsn11,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/nong-khai-bus-terminal/778',
    title: 'Bangkok ↔ Nong Khai',
    frequency: 'routes.Daily',
    price: '515THB',
  },
  {
    id: 12,
    image: dsn12,
    link: 'https://booking.ezseat.asia/bus/bangkok-bus-terminal-chatuchak-mo-chit-2/nong-khai-bus-terminal/778',
    title: 'Bangkok ↔ Nong Khai',
    frequency: 'routes.Daily',
    price: '515THB',
  },
  // Add more destinations as needed
];

const DestinationsCherdchai = () => {
  const { t } = useTranslation();
  
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="destination-area">
      <div className="container">
        <div className="wpo-section-title">
          <h2>{t('popular_destinations')}</h2>
        </div>
        <div className="row">
          {destinations_cc.map((destination) => (
            <div key={destination.id} className="col-6 col-md-4 col-lg-3">
              <a
                href={destination.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={ClickHandler}
              >
                <div className="destination-item">
                  <div className="destination-img">
                    <img src={destination.image} alt={t(destination.title)} loading="lazy" />
                  </div>
                  <div className="destination-content">
                    <div className="content-left">
                      <h5>{t(destination.title)}</h5>
                      <small>{t(destination.frequency)}</small>
                    </div>
                    <div className="content-right">
                      <h5>{destination.price}</h5>
                      <span>{t('starting')}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        <div className="btns text-center">
          <Link onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} to="/destination" className="theme-btn-s2">
            {t('discover_more')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DestinationsCherdchai;
